export default function Divider() {
    return (
        <div className='w-full flex'>
            <div className='w-full border-b border-[#201f1f] lg:border-neutral-600' />
        </div>
    )
}
